import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import ImageAsync from '../../../components/native/ImageAsync'

const SimpleAccordionItem = ({ icon, title, content }) => {

    const [state, setState] = useState('item-accordion-inactive');

    const iconOpen = <FontAwesomeIcon icon={faAngleDown} color='#000000' size='lg' />;

    const handleAccordion = () => {

        setState(state === 'item-accordion-inactive' ? 'item-accordion-active' : 'item-accordion-inactive');

    }

    const iconprop = ImageAsync({ src: "/assets/img/icons/" + icon, alt: "register icon", width: '32px', height: '32px' });

    return (
        <>
            <div className='w-full flex justify-between items-center p-2 mt-4' onClick={handleAccordion}>
                <div className='flex flex-row items-center'>
                    <div className='mr-4'>
                        {iconprop ? iconprop : <img src="/assets/img/icons/exit-icon.svg" alt="register icon" width={'32px'} height={'32px'} />}
                    </div>
                    <span className='accordion-item-title'>{title}</span>
                </div>
                <div className={'transition-arrow ' + (state === 'item-accordion-inactive' ? 'did-open' : 'did-close')}>
                    {iconOpen}
                </div>
            </div>
            <div className={'w-full transition-item ' + state}>
                <p dangerouslySetInnerHTML={{'__html':content}}>
                </p>
            </div>

            <div className='lineseparator w-full'></div>
        </>
    )
}

SimpleAccordionItem.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string
}

export default SimpleAccordionItem
